import { constantsData, urlsData } from "data";
import { useApisClient } from "hooks";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useGetDriveManagementFolder = (id) => {
    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { get } = useApisClient();

    useEffect(() => {
        if (id) {
            setLoading(true);

            get(
                `${urlsData.apis.driveManagement.files.url}/${id}`,
                null,
                null,
            ).then(({ data: responseData }) => setData(responseData))["catch"]((err) => {
                displayErrorHandler(
                    err.response.data.message === constantsData.networkError ? t("messages.networkFailure") : err.response.data.message,
                    dispatch,
                    openAlert,
                );
            })["finally"](() => {
                setLoading(false);
            });
        }
    },[id]); //eslint-disable-line

    return {
        data,
        loading,
    };
};

export default useGetDriveManagementFolder;
